import { Button } from "@asosteam/asos-web-component-library-button";
import {
  useLocaleProvider,
  useTranslate,
} from "../../../context/locale-provider";
import styles from "../styles";
import localStyles from "./styles";

const SuccessView = () => {
  const translate = useTranslate(useLocaleProvider());
  return (
    <div className={`${styles.card} ${localStyles.container}`}>
      <h1 className="app_barnsley2">
        {translate("premier_cancel_contracts_form_confirmation_title")}
      </h1>
      <p className="app_leavesden2">
        {translate("premier_cancel_contracts_form_confirmation_description")}
      </p>
      <Button
        className="app_button"
        elementOverride="a"
        href={window.location.origin}
      >
        {translate(
          "premier_cancel_contracts_form_confirmation_cta_continue_shopping"
        )}
      </Button>
    </div>
  );
};

export default SuccessView;
